import { createFileRoute } from '@tanstack/react-router'
import { ProductionOrderEditor } from './-ProductionOrderEditor'

export const Route = createFileRoute('/production/orders/$id')({
  component: () => {
    const { id } = Route.useParams()
    return <ProductionOrderEditor id={id} />
  },
})
